import { addInputData } from 'src/sales-keypad/business-logic/handle-sales-keypad-actions';
import { closeAllItems, IAllItemsProps, showAllItems } from '../../all-items/all-items';
import { ISelectedItem } from '../../common/interfaces/dtos/ISelectedItem';
import { popupMessage } from '../../messages/business-logic/popup-message';
import { resetSalesKeypadState } from '../../sales-keypad/business-logic/sales-keypad-operations';
import { sellPluItem } from './sell-plu-item';
import { EntryMethod } from 'src/common/enumerations/entry-method';
import { ScannedDataHandler } from 'src/devices/scanner-operations';
import {
  resetElectronicItemCallback,
  setElectronicItemCallback,
} from 'src/electronic-items/business-logic/handle-electronic-item';

type PluCallback = (
  selectedItem?: ISelectedItem,
  itemId?: string,
  entryMethod?: EntryMethod,
) => void;
let _pluCallback: PluCallback | undefined;

export const setPluCallback = (callback: PluCallback): void => {
  _pluCallback = callback;
};

export const resetPluCallback = (): void => {
  _pluCallback = undefined;
};

export const openProductDisplay = (selectedTab: number, trainingModeActive: boolean): void => {
  const onProductSelected = async (selectedItem: ISelectedItem): Promise<void> => {
    if (_pluCallback) {
      _pluCallback(selectedItem, undefined, EntryMethod.Tapped);
      closeAllItems();
    } else {
      return sellPluItem(selectedItem)
        .catch(popupMessage)
        .finally(resetSalesKeypadState);
    }
  };

  const onFinish = async (): Promise<void> => {
    resetElectronicItemCallback();
    closeAllItems();
  };

  const onKeypadSubmit = async (input: string): Promise<void> => {
    if (input) {
      if (_pluCallback) {
        _pluCallback(undefined, input, EntryMethod.Keyed);
      } else {
        return addInputData(input).catch(popupMessage);
      }
    }
  };

  const electronicItemCallback = async (): Promise<void> => {
    showAllItems(allItemProps);
  };

  // electronic item callback is releveant only when the flow was started at plu menu
  if (!_pluCallback) {
    setElectronicItemCallback(electronicItemCallback);
  }

  const allItemProps: IAllItemsProps = {
    onProductSelected,
    onFinish,
    onKeypadSubmit,
    pluTabValue: selectedTab,
    trainingModeActive,
  };
  showAllItems(allItemProps);
};

export const onScanned: ScannedDataHandler = async (scannedData: string): Promise<void> => {
  if (scannedData) {
    if (_pluCallback) {
      _pluCallback(undefined, scannedData, EntryMethod.Scanned);
    } else {
      return addInputData(scannedData).catch(popupMessage);
    }
  }
};
